import { Link, Typography, styled } from '@ori-ui/mui';
import { StaticNavigationNavigationItemDtoLinkType } from '@ori/static-api-client-react';
import React from 'react';

import { useAppConfig, useFooterContext } from '../../hooks';
import { extractFooterNavigationType, extractChildrenWithNavigationType } from '../../utils';
import { MobileAppIcon } from './MobileAppIcon';
import { SuperApp } from './SuperApp';

const Root = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: theme.spacing(6),
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const IconHolder = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const Icon = styled('div')(({ theme }) => ({
  display: 'inline-block',
  margin: theme.spacing(1, 2),
  width: 35,
  height: 35,
  overflow: 'hidden',
}));

export const MobileApps: React.FC = () => {
  const { data } = useFooterContext();
  const { tenant } = useAppConfig();

  if (!data?.application) {
    return null;
  }

  const footer = extractFooterNavigationType(data);
  const ourApps = extractChildrenWithNavigationType(StaticNavigationNavigationItemDtoLinkType.OurApps, footer);

  return (
    <Root>
      <StyledTypography variant="h6">{data.mobileApps?.pageHeader?.title}</StyledTypography>
      {tenant === 'cn' && (
        <IconHolder>
          <Icon>
            <SuperApp />
          </Icon>
        </IconHolder>
      )}
      {!(tenant === 'cn') && (
        <>
          <IconHolder>
            {data.mobileApps?.mobileAppCollection.map((app, index) => (
              <Icon key={app.title ?? index}>
                <MobileAppIcon
                  title={app.title ?? ''}
                  titleImage={app.titleImage ?? ''}
                />
              </Icon>
            ))}
          </IconHolder>
          <Link
            href={ourApps?.url ?? '#'}
            variant="body2"
            align="center"
          >
            {ourApps?.title ?? ''}
          </Link>
        </>
      )}
    </Root>
  );
};
